<script lang="ts">
    import { getContext } from 'svelte';

    export let onOkay = (value: string) => {};
    export let onCancel = () => {};
    export let title = "Demande de confirmation";
    export let content = "Vous confirmez?";
    export let confirmText = "Ajouter";
    export let cancelText = "Annuler";

    let valueUrl: string;

    const { close } = getContext('simple-modal');

    /**
     * cancel and close the modal
     */
    function _onCancel() {
        onCancel();
        close();
    }

    /**
     * confirm and close the modal
     */
    function _onOkay() {
        onOkay(valueUrl);
        close();
    }




</script>

<div id="form">
    <div id="title">
        <h2>{title}</h2>
    </div>
    <div class="field">
        <p class="control has-icons-left">
        <input id=urlInput class="input" type="url" placeholder="https://example.com"
               pattern="https://.*" bind:value={valueUrl}/>
        <span class="icon is-small is-left">
            <i class="fas fa-link"></i>
        </span>
        </p>
    </div>


    <div id="submit">
        <button id="btn-ok" type="submit" on:click={_onOkay}>
            {confirmText}
        </button>
        <button id="btn-cancel" on:click={_onCancel}>
            {cancelText}
        </button>
    </div>
</div>

<style lang="scss">
  @import "../styles/variables";

    #form{
      margin: 40px;
      h2 {
        font-size: 26px;
        line-height: 30px;
        font-weight: bold;
      }
      h3{
        font-size: 18px;
        line-height: 28px;
        font-weight: bold;
      }

      input{
        width: 100%;
      }

    // .product-name{
    //   color: $orange
    // }

      #submit{
        width: 100%;
        button{
          width: 100%;
          border:none;
          outline: none;
          border-radius: 100px;
          height: 40px;
          margin: 10px 0;
          cursor: pointer;
          font-weight: bold;
        }
        #btn-ok{
          background-color: $dark-black;
          color: white;
          &:disabled{
            background-color: $grey-darken;
            cursor: default;
          }
        }
        #btn-cancel{
          //display: none;
        }
      }
    }

    @media (max-width: 1024px) {
      #form{
        margin: 10px;
        #submit{
          button{
            height: 60px;
            font-size: 1.2rem;
          }
          #btn-cancel{
            display: block;
            background-color: $grey-light;
            color: $blue;
          }
        }
      }
    }

</style>
